// @config
import { xervixApi } from '../config/axios.config';

// @constants
import { API_ROUTES } from '../constants/apiRoutes';

// @types
import {
  CreateServiceRequest,
  UploadImagesRequest,
  RequestFilters,
  ServiceRequestDetailsResponse,
  ServiceRequestResponse,
  IServiceById,
  IParamsServiceReques,
} from '../types/request.types';

const submitServiceRequest = async (data: CreateServiceRequest): Promise<{ serviceRequestId: string }> => {
  try {
    const response = await xervixApi.post(API_ROUTES.REQUEST.SUBMIT_REQUEST, data);
    return response.data;
  } catch (error: any) {
    if (error.response) {
      throw error;
    }
    throw new Error(error);
  }
};

const uploadImagesServiceRequest = async (serviceRequestId: string, dataFields: UploadImagesRequest): Promise<any> => {
  const formData = new FormData();
  dataFields.files.forEach((file) => {
    formData.append('images', file);
  });
  const response = await xervixApi.post(
    API_ROUTES.REQUEST.UPLOAD_IMAGES(serviceRequestId),
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );
  return response.data;
};

const fetchModeServiceRequest = async (): Promise<any> => {
  const response = await xervixApi.get(
    API_ROUTES.ENUMS.SERVICE_MODES
  );
  return response.data;
};

const fetchRequestsByUser = async (): Promise<any> => {
  const response = await xervixApi.get(
    API_ROUTES.REQUEST.FETCH_REQUESTS,
    {
      params: {
        //serviceRequestStatus: 2,
        createdByMe: true,
        pageSize: 100,
        pageNumber: 1
      },
    }
  );
  return response.data;
}

const fetchRequestByStatus = async (
  serviceRequestId?: string,
  serviceRequestStatus?: String,
  createdByMe?: boolean
): Promise<any> => {
  try {
    const response = await xervixApi.get(API_ROUTES.REQUEST.FETCH_REQUESTS, {
      params: {
        serviceRequestId: serviceRequestId,
        serviceRequestStatus: serviceRequestStatus,
        createdByMe: createdByMe,
        pageSize: 100,
        pageNumber: 1
      },
    }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

const fetchFilteredRequests = async (filters: RequestFilters): Promise<any> => {
  const response = await xervixApi.get(API_ROUTES.REQUEST.FETCH_REQUESTS, {
    params: {
      ...filters
    }
  });
  return response.data;
};


const fetchServiceRequestDetails = async (
  page = 1,
  pageSize = 10,
  orderBy = "createdDate",
  sortDirection = "desc"
): Promise<ServiceRequestDetailsResponse> => {
  const response = await xervixApi.get(API_ROUTES.REQUEST.FETCH_REQUEST_DETAILS, {
    params: { page, pageSize, orderBy, sortDirection },
  });
  return response.data;
};

const fetchActiveForProfessional = async (filters: RequestFilters): Promise<ServiceRequestResponse> => {
  const response = await xervixApi.get(API_ROUTES.REQUEST.FETCH_ACTIVE_FOR_PROFESSIONAL, {
    params: filters
  });
  return response.data;
};

//Arlei

const getServiceById = async (serviceId: string): Promise<IServiceById> => {
  try {
    const response = await xervixApi.get(API_ROUTES.REQUEST.GET_BY_ID(serviceId));
    return response.data;
  } catch (error) {
    throw error;
  }
}

const fetchRequestByStatusList = async (params: IParamsServiceReques): Promise<ServiceRequestResponse> => {
  try {
    const response = await xervixApi.get(API_ROUTES.REQUEST.FETCH_REQUESTS, {
      params: {
        serviceRequestStatus: params.statusList,
        createdByMe: params.createdByMe,
        categoryId: params.categoryId,
        pageSize: 1000,
        pageNumber: 1
      },
      paramsSerializer: (params) => {
        return Object.keys(params)
          .map((key) =>
            Array.isArray(params[key])
              ? params[key].map((val: any) => `${key}=${val}`).join('&')
              : `${key}=${params[key]}`
          )
          .join('&');
      },
    }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

const fetchRequestCreatedStatus = async (): Promise<ServiceRequestResponse> => {
  try {
    const response = await xervixApi.get(API_ROUTES.REQUEST.FETCH_REQUESTS, {
      params: {
        serviceRequestStatus: 0,
        createdByMe: true,
        pageSize: 100,
        pageNumber: 1
      },
    }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

/* const fetchRequestCanceledStatus = async (): Promise<ServiceRequestResponse> => {
  try {
    const response = await xervixApi.get(API_ROUTES.REQUEST.FETCH_REQUESTS, {
      params: {
        serviceRequestStatus: 3,
        createdByMe: true,
      },
    }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
} */

const methodsRequest = {
  submitServiceRequest,
  uploadImagesServiceRequest,
  fetchModeServiceRequest,
  fetchRequestsByUser,
  fetchRequestByStatus,
  fetchFilteredRequests,
  fetchServiceRequestDetails,
  fetchActiveForProfessional,
  getServiceById,
  fetchRequestByStatusList,
  fetchRequestCreatedStatus,
  //fetchRequestCanceledStatus
};

export default methodsRequest;
